export default __webpack_public_path__ + "0b125c6564d7751b6acc5f7890c4a9ae.webp";